import React, { useState } from 'react'
import Modal from '../../../components/shared/modal'
import DeviceForm from './device-form'
import { useTranslation } from 'react-i18next'

interface DeviceEntity {
    uid?: string
    name?: string
    [key: string]: unknown
}

interface EditDeviceProps {
    updatedDevice?: DeviceEntity
    onModalClose?: (device?: DeviceEntity) => void
    children?: React.ReactElement
}

export const EditDevice = ({
    updatedDevice,
    onModalClose,
    children,
}: EditDeviceProps) => {
    const [modalOpen, setModalOpen] = useState(false)

    const { t } = useTranslation()

    if (!modalOpen) {
        if (children) {
            return React.cloneElement(children, { onClick: () => setModalOpen(true) })
        }

        return null
    }

    return (
        <Modal
            dialogClass="modal-lg"
            description={updatedDevice?.uid ? t('device.modal.edit', { deviceName: updatedDevice.name }) : t('device.modal.add')}
            handleHideModal={() => {
                setModalOpen(false)
                onModalClose?.(updatedDevice)
            }}
            content={() => (
                <div className="p-3">
                    <DeviceForm
                        updatedDevice={updatedDevice as Record<string, unknown>}
                        setEditedCompanyForm={() => {}}
                        successAction={() => {
                            setModalOpen(false)
                            onModalClose?.(updatedDevice)
                        }}
                    />
                </div>
            )}
        />
    )
}
